export default __webpack_public_path__ + "static/media/helm_of_ferine_anger.a55546f8.jpg";